<div class="ui modal" id="BettingSlip_Balance_Info_Modal">
    <div style="text-align: center;font-size: 20px;font-weight: bold;margin:6px">
        <span tkey="Info_Payout_balance"></span>
    </div>
    <div style="text-align:center;margin:6px">
        <span tkey="You_can_print_a_recipt_for_your_balance_The_balance_you_can_cashing_out_from_an_employee"></span>
    </div>
    <div style="text-align:center;margin:12px">
        <button class="ui button" (click)="Balance_Info_Modal_Button_Ok()">
            <span tkey="Ok"></span>
        </button>
    </div>
</div>